import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=86bba1f2&scoped=true&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"
import style0 from "./steps.vue?vue&type=style&index=0&id=86bba1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bba1f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86bba1f2')) {
      api.createRecord('86bba1f2', component.options)
    } else {
      api.reload('86bba1f2', component.options)
    }
    module.hot.accept("./steps.vue?vue&type=template&id=86bba1f2&scoped=true&", function () {
      api.rerender('86bba1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settle-cfnb/steps.vue"
export default component.exports